// Mobx-backed TabbedSection component
import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import { observer } from "mobx-react";
import classNames from "classnames";
import filter from "lodash/filter";
import noop from "lodash/noop";
import { Buttonize } from "util/a11y";
import TabbedSectionModel from "gradifui/models/TabbedSectionModel";
import { ActionRootContext } from "higher-order/ActionRoot";

@observer
class TabbedSection extends React.Component {
    static propTypes = {
        model: PropTypes.instanceOf(TabbedSectionModel).isRequired,
        className: PropTypes.string,
        renderBodyAsListItem: PropTypes.bool
    }

    static contextType = ActionRootContext;

    static defaultProps() {
        return {
            renderBodyAsListItem: false
        };
    }

    componentDidMount() {
        this.props.model.updateAnchorMap(filter(this.props.children, child => child && child.type === TabbedSection.Tab));
        this.props.model.updateHistory();
    }

    setActiveTab(tab) {
        const model = this.props.model;
        if (!tab.props.isDisabled) {
            model.changeTab(tab.props.index, false, (tab.props.anchor ? "#" + tab.props.anchor : null));
            if (tab.props.anchor) {
                window.location.href = window.location.href.split("#")[0] + "#" + tab.props.anchor;
            }
            if (this.props.onChangeTab) {
                this.props.onChangeTab(tab.props.index);
            }
            // for hooks
            this.context.dispatcher.emit("SET_ACTIVE_TAB", {
                tabIndex: tab.props.index
            });
        }
    }

    render() {
        const classes = classNames(
            this.props.className,
            "tabbed-section"
        );

        const model = this.props.model;

        const body = (
            <div className={classNames("tabbed-section-body")}>
                {React.Children.map(this.props.children, child => {
                    if (child && child.type === TabbedSection.Panel && model.activeTab === child.props.index) {
                        return child;
                    }
                    return null;
                })}
            </div>
        );

        return (
            <div className={classes}>
                <div className="tabbed-section-nav">
                    <ul>
                        {this.props.model.showArrows &&
                            <Buttonize onClick={this.props.model.previousTab} label="Navigate to Previous Tab">
                                <li className="arrow prev-tab">
                                    <i className="icon-left-open" />
                                </li>
                            </Buttonize>
                        }
                        {React.Children.map(this.props.children, child => {
                            const isActive = child && model.activeTab === child.props.index;
                            if (child && child.type === TabbedSection.Tab && !child.props.hidden) {
                                return (
                                    <React.Fragment>
                                        {React.cloneElement(child, {
                                            isActive: isActive,
                                            onClick: this.setActiveTab.bind(this, child)
                                        })}
                                        {isActive && this.props.renderBodyAsListItem &&
                                            <li className="body-item">
                                                {body}
                                            </li>
                                        }
                                    </React.Fragment>
                                );
                            }
                            return null;
                        })}
                        {this.props.model.showArrows &&
                            <Buttonize onClick={this.props.model.nextTab} label="Navigate to Next Tab">
                                <li className="arrow next-tab" >
                                    <i className="icon-right-open" />
                                </li>
                            </Buttonize>
                        }
                    </ul>
                </div>
                {!this.props.renderBodyAsListItem && body}
            </div>
        );
    }
}

TabbedSection.Tab = createReactClass({
    propTypes: {
        index: PropTypes.number.isRequired,
        isActive: PropTypes.bool.isRequired,
        isDisabled: PropTypes.bool,
        hidden: PropTypes.bool,
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        onChangeTab: PropTypes.func
    },
    getDefaultProps() {
        return {
            isDisabled: false,
            hidden: false,
            isActive: false,
            onClick: noop
        };
    },
    render() {
        const classes = classNames(
            this.props.className,
            "tabbed-section-tab",
            this.props.isActive && !this.props.isDisabled && "selected", // add the selected class if this is the tab for the active tab
            this.props.isDisabled && "disabled" // add the selected class if this is the tab for the active tab
        );
        if (!this.props.hidden) {
            return (
                <Buttonize onClick={this.props.onClick} label={`Tab ${this.props.index}`} pressed={this.props.isActive}>
                    <li className={classes} key={"tab-" + this.props.index}>
                        {this.props.children}
                    </li>
                </Buttonize>
            );
        }
        return (<li />);
    }
});

TabbedSection.Panel = createReactClass({
    propTypes: {
        index: PropTypes.number.isRequired,
        hidden: PropTypes.bool,
        className: PropTypes.string
    },
    getDefaultProps() {
        return {
            hidden: false
        };
    },
    render() {
        if (!this.props.hidden) {
            const classes = classNames("tabbed-section-panel", this.props.className);
            return (
                <div className={classes} key={"panel-" + this.props.index}>
                    {this.props.children}
                </div>
            );
        }
        return (<div />);
    }
});

export default TabbedSection;
